/* istanbul ignore file */
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import CheckBox from 'yoda-core-components/lib/components/CheckBox';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';

const PromotionalEmailOptIn = ({
    messagesTexts = {},
    isOptedEmail = false,
    email = '',
    actions = {},
}) => {
    const isOptedEmailStorage =
        typeof LocalStorage.getData('isEmailOpted', true) === 'object'
            ? null
            : LocalStorage.getData('isEmailOpted', true) === 'true';
    const [checked, setChecked] = useState(
        typeof isOptedEmailStorage === 'boolean' ? isOptedEmailStorage : isOptedEmail
    );

    const checkboxConfig = {
        id: 'promotionalEmail',
    };
    const onCheckboxClickHandler = () => {
        LocalStorage.setData('isEmailOpted', !checked, true);
        setChecked(!checked);
    };

    useEffect(() => {
        if (checked) {
            const payload = {
                type: 'EMAIL',
                purpose: 'MARKETING',
                value: email,
            };
            actions.setPromotionalEmailSelection(payload);
        } else {
            actions.setPromotionalEmailSelection({});
        }
    }, [checked]);

    return (
        <div
            data-automation-id="transactional-sms-container"
            className={dt(['bg-light-white', 'pl-3', 'pr-3', 'pb-[20px]', 'rounded-lg'])}
        >
            <div id="amr-co-promotional-email-alerts-checkbox" className={dt(['flex', 'ml-0'])}>
                <CheckBox
                    id={checkboxConfig.id}
                    name={checkboxConfig.id}
                    label={messagesTexts.PROMOTIONAL_EMAIL_CONSENT_LABEL}
                    automationId="at-transaction-sms-checkbox"
                    checked={checked}
                    onClick={onCheckboxClickHandler}
                    className={dt(['mb-4', 'font-bold'])}
                />
            </div>

            <div>
                <div className={dt(['ml-8', '-mt-4', 'pl-1'])}>
                    <p
                        className={dt([
                            'text-medium',
                            'font-open-sans-regular',
                            'text-black',
                            'p-0',
                            'mb-1',
                        ])}
                    >
                        {messagesTexts?.PROMOTIONAL_EMAIL_DETAILS}
                    </p>
                    <p>
                        <a
                            href={messagesTexts?.privacyNoticeLink}
                            target="_blank"
                            className={dt([
                                'underline',
                                'text-medium',
                                'font-open-sans-regular',
                                'text-black',
                                'p-0',
                                'm-0',
                                'cursor-pointer',
                            ])}
                            rel="noreferrer"
                        >
                            Privacy Notice
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

PromotionalEmailOptIn.defaultProps = {
    messagesTexts: {},
    isOptedEmail: false,
    email: '',
    actions: {},
};

PromotionalEmailOptIn.propTypes = {
    messagesTexts: PropTypes.object,
    isOptedEmail: PropTypes.bool,
    email: PropTypes.string,
    actions: PropTypes.object,
};

export default PromotionalEmailOptIn;
